module.exports = __webpack_public_path__ + "img/Car_tyre.09ccb31d.svg";